import React, { useState } from "react";
import axios from "../api";
import { useHistory } from "react-router-dom";
import AjusteFechaTurnoTable from "./AjusteFechaTurnoTable";
import AjusteFechaDiaTable from "./AjusteFechaDiaTable";
import "../cierreTurno/CierreTurno.css";

const AjusteFechaContainer = () => {
  const [cierreTurnoData, setCierreTurnoData] = useState([]);
  const [cierreDiaData, setCierreDiaData] = useState([]);
  const [cargando, setCargando] = useState(false);

  const [filtros, setFiltros] = useState({
    centroCostos: "",
    codTerminal: "",
    fechaInicial: "",
  });

  const history = useHistory();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFiltros((prev) => ({ ...prev, [name]: value }));
  };

  const handleBuscar = async (e) => {
    e.preventDefault();
    const { centroCostos, codTerminal, fechaInicial } = filtros;

    if (!centroCostos || !codTerminal || !fechaInicial) {
      alert(
        "Por favor complete todos los campos: Centro de costos, Código terminal y Fecha."
      );
      return;
    }

    const fechaRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (!fechaRegex.test(fechaInicial)) {
      alert("El formato de fecha debe ser YYYY-MM-DD");
      return;
    }

    const payload = {
      codTerminal,
      codPark: centroCostos,
      fechaInicial,
    };

    setCargando(true);
    try {
      const [resTurno, resDia] = await Promise.all([
        axios.post("/cierre-turno/filtrar", payload),
        axios.post("/cierres-dias/buscar", payload),
      ]);

      setCierreTurnoData(Array.isArray(resTurno.data) ? resTurno.data : []);
      setCierreDiaData(Array.isArray(resDia.data) ? resDia.data : []);
    } catch (error) {
      console.error("Error al buscar:", error);
      alert(
        error.response?.data?.message ||
          error.message ||
          "Error al consultar cierres."
      );
      setCierreTurnoData([]);
      setCierreDiaData([]);
    } finally {
      setCargando(false);
    }
  };

  const handleLimpiar = () => {
    setFiltros({ centroCostos: "", codTerminal: "", fechaInicial: "" });
    setCierreTurnoData([]);
    setCierreDiaData([]);
  };

  const handleVolverHome = () => {
    history.push('/Planillas');
  };

  const recargarTabla = async () => {
    const { centroCostos, codTerminal, fechaInicial } = filtros;
    if (!centroCostos || !codTerminal || !fechaInicial) return;

    const payload = {
      codTerminal,
      codPark: centroCostos,
      fechaInicial,
    };

    try {
      const [resTurno, resDia] = await Promise.all([
        axios.post("/cierre-turno/filtrar", payload),
        axios.post("/cierres-dias/buscar", payload),
      ]);
      setCierreTurnoData(Array.isArray(resTurno.data) ? resTurno.data : []);
      setCierreDiaData(Array.isArray(resDia.data) ? resDia.data : []);
    } catch (error) {
      console.error("Error al recargar:", error);
    }
  };

  return (
    <div className="cierre-turno-container">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <h2 className="cierre-turno-title">Ajuste de Fecha</h2>
        <button
          onClick={handleVolverHome}
          style={{
            padding: "10px 20px",
            backgroundColor: "#007bff",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: "14px",
            fontWeight: "bold",
          }}
          onMouseOver={(e) => (e.target.style.backgroundColor = "#0056b3")}
          onMouseOut={(e) => (e.target.style.backgroundColor = "#007bff")}
        >
          ← Volver al Home
        </button>
      </div>

      <form
        onSubmit={handleBuscar}
        className="cierre-turno-form"
        style={{ marginBottom: "20px" }}
      >
        <div className="form-row">
          <div className="form-group">
            <label>Centro de costos:</label>
            <input
              type="text"
              name="centroCostos"
              value={filtros.centroCostos}
              onChange={handleChange}
              placeholder="Ej: 447"
            />
          </div>
          <div className="form-group">
            <label>Código terminal:</label>
            <input
              type="text"
              name="codTerminal"
              value={filtros.codTerminal}
              onChange={handleChange}
              placeholder="Ej: P447"
            />
          </div>
          <div className="form-group">
            <label>Fecha (fecha_inicial):</label>
            <input
              type="date"
              name="fechaInicial"
              value={filtros.fechaInicial}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="form-buttons">
          <button type="submit" className="buscar-btn" disabled={cargando}>
            {cargando ? "Buscando..." : "Buscar"}
          </button>
          <button type="button" className="cancelar-btn" onClick={handleLimpiar}>
            Limpiar
          </button>
        </div>
      </form>

      {cierreTurnoData.length > 0 && (
        <div className="table-container">
          <h3>Resultados Cierre de Turno (solo edición de fecha)</h3>
          <AjusteFechaTurnoTable
            cierres={cierreTurnoData}
            recargarTabla={recargarTabla}
          />
        </div>
      )}

      {cierreDiaData.length > 0 && (
        <div className="table-container" style={{ marginTop: "10px" }}>
          <h3>Resultados Cierre Día (solo edición de fecha)</h3>
          <AjusteFechaDiaTable
            cierres={cierreDiaData}
            recargarTabla={recargarTabla}
          />
        </div>
      )}

      {!cargando &&
        cierreTurnoData.length === 0 &&
        cierreDiaData.length === 0 &&
        filtros.centroCostos &&
        filtros.codTerminal &&
        filtros.fechaInicial && (
          <p style={{ marginTop: "20px", color: "#666" }}>
            No se encontraron registros para los filtros indicados.
          </p>
        )}
    </div>
  );
};

export default AjusteFechaContainer;
